module.exports = __webpack_public_path__ + "static/media/trimble.05966cb1.png";